<template>
  <div>
    <div class="grid grid-cols-2 col-gap-8">
      <div v-for="(type,i) in space_types" :key="i"
           class="flex items-center cursor-pointer group border border-border rounded hover:border-green transition duration-200"
           style="padding: 1.2rem;"
           :class="{'bg-green-extraLight border-green': type.val === selected}"
           @click="$emit('change',type.val)">
        <div class="w-12 text-center">
          <component :is="`icon-${type.icon}`"
                     :class="{'md:text-green': type.val === selected}"
                     class="text-icon-hover transition duration-200"/>
        </div>
        <div class="ml-6 text-text text-sm transition duration-200" :class="{'text-green': type.val === selected}">{{ type.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import IconFamily from "@/components/icons/SpaceTypePicker/IconFamily";
import IconPersonal from "@/components/icons/SpaceTypePicker/IconPersonal";

export default {
  name: "SpaceTypePicker2",
  components: {IconFamily, IconPersonal},
  props: {
    selected: {
      type: Number,
      required: true,
      validator: (val) => [1, 2, 3].includes(val)
    }
  },
  data() {
    return {
      space_types: [
        {val: 1, icon: 'personal', name: this.$t('personal')},
        {val: 2, icon: 'family', name: this.$t('family')}
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        personal: 'For myself',
        family: 'For family',
      },
      ru: {
        personal: 'Для себя',
        family: 'Для семьи',
      },
    }
  }
}
</script>